import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../contexts/AuthContext';

export default function Stores() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stores, setStores] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState('');
  const [msg, setMsg] = useState('');
  const [editStore, setEditStore] = useState(null);

  const load = () => api.get('/stores').then(r => setStores(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    await api.post('/stores', { name });
    setShowModal(false);
    setName('');
    load();
  };

  const saveEdit = async (e) => {
    e.preventDefault();
    setMsg('');
    try {
      await api.put(`/stores/${editStore.id}`, { name: editStore.name });
      setMsg('¡Tienda actualizada!');
      setEditStore(null);
      load();
    } catch (err) {
      setMsg(err.response?.data?.detail || 'Error');
    }
  };

  const handleDelete = async (e, store) => {
    e.stopPropagation();
    if (!window.confirm(`¿Eliminar tienda "${store.name}"?`)) return;
    setMsg('');
    try {
      const res = await api.delete(`/stores/${store.id}`);
      setMsg(res.data.message);
      load();
    } catch (err) {
      setMsg(err.response?.data?.detail || 'Error');
    }
  };

  return (
    <div>
      <div className="page-header">
        <h1>Tiendas</h1>
        {user?.role === 'admin' && <button className="btn btn-primary" onClick={() => setShowModal(true)}>Agregar Tienda</button>}
      </div>

      {msg && <div className={`alert ${msg.includes('archived') ? 'alert-warning' : msg.includes('deleted') || msg.includes('actualizada') ? 'alert-success' : 'alert-danger'}`}>{msg}</div>}

      <div className="card-grid">
        {stores.map(store => (
          <div className="stat-card" key={store.id} style={{ cursor: 'pointer', position: 'relative' }} onClick={() => navigate(`/stores/${store.id}/inventory`)}>
            <div className="label">Tienda</div>
            <div className="value" style={{ fontSize: 20 }}>{store.name}</div>
            <div style={{ marginTop: 8 }}>
              <span className={`badge ${store.is_active ? 'badge-success' : 'badge-danger'}`}>
                {store.is_active ? 'Activo' : 'Inactivo'}
              </span>
            </div>
            {user?.role === 'admin' && (
              <div style={{ position: 'absolute', top: 8, right: 8, display: 'flex', gap: 4 }}>
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={(e) => { e.stopPropagation(); setEditStore({ id: store.id, name: store.name }); }}
                >
                  Editar
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={(e) => handleDelete(e, store)}
                >
                  Eliminar
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Agregar Tienda</h2>
            <form onSubmit={save}>
              <div className="form-group">
                <label>Nombre de Tienda</label>
                <input value={name} onChange={e => setName(e.target.value)} required autoFocus />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary">Crear</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {editStore && (
        <div className="modal-overlay">
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Editar Tienda</h2>
            <form onSubmit={saveEdit}>
              <div className="form-group">
                <label>Nombre de Tienda</label>
                <input value={editStore.name} onChange={e => setEditStore({...editStore, name: e.target.value})} required autoFocus />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setEditStore(null)}>Cancelar</button>
                <button type="submit" className="btn btn-primary">Guardar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
